import type { AccordionData } from "@/design-system/Molecules/AccordionList/Accordion.types";

export const medicalSideEffectsData: AccordionData[] = [
    {
        question: "Cardiac and Pulmonary",
        answer: (
            <p>
                Patients should discontinue use of PDE5 inhibitor medication immediately and seek medical attention if they experience: shortness of breath, chest pain or discomfort, fainting or severe dizziness, Systolic blood pressure below 105, diastolic blood pressure below 65(105/ 65).
            </p>
        ),
    },
    {
        question: "Priapism",
        answer: (
            <p>
                In the event of an erection that persists longer than 4 hours, the patient should seek immediate medical assistance.If priapism is not treated immediately, penile tissue damage and permanent loss of potency could result.
            </p>
        ),
    },
    {
        question: "Hearing Loss",
        answer: (
            <p>
                Patients should immediately stop taking PDE5 inhibitors and seek prompt medical attention in the event of sudden decrease or loss of hearing.These events, which may be accompanied by tinnitus and dizziness, have been rarely reported in temporal association to the intake of PDE5 inhibitors.It is not possible to determine whether these events are related directly to the use of PDE5 inhibitors or to other factors.
            </p>
        ),
    },
    {
        question: "Visual Side Effects",
        answer: (
            <p>
                Patient should immediately discontinue use of PDE5 inhibitors if they experience any visual side effects.Patients should seek immediate medical attention in the event of a sudden loss of vision in one or both eyes.
            </p>
        ),
    },
    {
        question: "Disclaimer for Sexually Transmitted Diseases",
        answer: (
            <p>
                The use of PDE5 inhibitors offers no protection against sexually transmitted diseases.Individuals should take protective measures necessary to guard against sexually transmitted diseases, including the Human Immunodeficiency Virus(HIV).
            </p>
        ),
    },
    {
        question: "Adverse Reactions Incidence (Dose Dependent)",
        answer: (
            <div className="overflow-x-auto" >
                <table className="w-full table-auto border border-gray-300 text-sm text-left" >
                    <thead className="bg-gray-100" >
                        <tr>
                            <th className="border px-3 py-2" > Symptom </th>
                            < th className="border px-3 py-2" > Percentage </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            [
                                { symptom: "Headache", percent: "16%" },
                                { symptom: "Flushing", percent: "10%" },
                                { symptom: "Dyspepsia", percent: "7%" },
                                { symptom: "Nasal Congestion", percent: "4%" },
                                { symptom: "Abnormal Vision", percent: "3%" },
                                { symptom: "Back pain", percent: "2%" },
                                { symptom: "Dizziness", percent: "2%" },
                                { symptom: "Rash", percent: "2%" },
                            ].map(({ symptom, percent }) => (
                                <tr key={symptom} >
                                    <td className="border px-3 py-2" > {symptom} </td>
                                    < td className="border px-3 py-2" > {percent} </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        ),
    },
];
